let GetFilename = (s) => s.split('/').pop().split('.')[0]
let ToPascalCase = (s) => s.split(/[-_]/).filter(w => w).map(w => w[0].toUpperCase() + w.slice(1)).join('')

function getModules(context) {
    return context.keys()
        .map(key => ({ key: ToPascalCase(GetFilename(key)), module: context(key) }))
        .filter(file => file.key && file.module)
}

export function importDefaults(context) {
    return getModules(context).filter(file => file.module.default)
        .reduce((defaults, file) => ({ ...defaults, [file.key]: file.module.default }), {})
}

export function importExports(context) {
    return getModules(context).map(file => Object.entries(file.module).filter(a => a[0] != 'default'))
        .reduce((exports, entries) => ({ ...exports, ...Object.fromEntries(entries)}), {})
}
export function importAll(context) {
    return { ...importDefaults(context), ...importExports(context) }
}